import { ScrollRestoration, Outlet } from 'react-router-dom';
import { QueryClientProvider } from 'react-query';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { AppProvider } from './context';
import { queryClient } from './services';
import {
  GlobalThemeProvider,
  MobileHeightControl,
  BackdropLoading,
  Snackbar,
  InstallAppModal,
} from './design-system';
import { usePwaAutoInstall, useVhControlEffect } from './hooks';

export const App = () => {
  useVhControlEffect();
  usePwaAutoInstall();

  return (
    <AppProvider>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <GlobalThemeProvider>
            <Outlet />
            <ScrollRestoration />
            <MobileHeightControl />
            <BackdropLoading />
            <Snackbar />
            <InstallAppModal />
          </GlobalThemeProvider>
        </LocalizationProvider>
      </QueryClientProvider>
    </AppProvider>
  );
};
